import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { getTermsAndConditions } from '../api/termsAndConditionsApi';

const TermsAndConditionsContext = createContext({
    documentUrl: null,
    documentName: null
});

export const TermsAndConditionsProvider = ({ children }) => {
    const [termsData, setTermsData] = useState({
        documentUrl: null,
        documentName: null
    });

    useEffect(() => {
        const fetchTerms = async () => {
            const { data } = await getTermsAndConditions();
            if (data && data.documentUrl) {
                setTermsData({
                    documentUrl: data.documentUrl,
                    documentName: data.documentName || null
                });
            }
        };
        fetchTerms();
    }, []);

    return (
        <TermsAndConditionsContext.Provider value={termsData}>
            {children}
        </TermsAndConditionsContext.Provider>
    );
};

TermsAndConditionsProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useTermsAndConditions = () =>
    useContext(TermsAndConditionsContext);
